import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";

export default class CardAdminProviderCredentialing extends CardClass {
  /**
   * Render the content of the card.
   */
  renderContent() {
    return (
      <MUIGrid container spacing={2}>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUITextField
            value={
              this.props.provider && this.props.provider.npi
                ? this.props.provider.npi
                : ""
            }
            size="small"
            label="NPI"
            variant="standard"
            fullWidth={true}
            inputProps={{
              maxLength: 10,
              inputMode: "numeric", // Show numeric keyboard on mobile
            }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, ""); // Allow only digits
              this.props.onChange({ npi: value });
            }}
            required={true}
            error={this.props.validationIssues.npi ? true : false}
            helperText={
              this.props.validationIssues.npi
                ? this.props.validationIssues.npi
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUITextField
            value={
              this.props.provider && this.props.provider.credential
                ? this.props.provider.credential
                : ""
            }
            size="small"
            label="Credential"
            variant="standard"
            fullWidth={true}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) =>
              this.props.onChange({ credential: e.target.value.trim() })
            }
            onChange={(e) =>
              this.props.onChange({ credential: e.target.value })
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUIFormControlLabel
            control={<MUISwitch />}
            onChange={(e) =>
              this.props.onChange({
                pecosCertified: e.target.checked ? e.target.checked : false,
              })
            }
            label="PECOS Certified"
            checked={
              !!(this.props.provider && this.props.provider.pecosCertified)
            }
          />
        </MUIGrid>
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Credentialing";
  }
}
